import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12361 20200"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:292.757}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278268192">
        <path
          d="M343 6655c262 263 688 263 950 0 262-262 262-687 0-949-262-263-688-263-950 0-262 262-262 687 0 949zM2130 4868c263 262 688 262 950 0 262-263 262-688 0-950-263-262-688-262-950 0s-262 687 0 950zM3918 3080c262 263 688 263 950 0 262-262 262-687 0-949-262-263-688-263-950 0-263 261-263 687 0 949zM5705 1293c263 262 688 262 950 0 263-263 263-688 0-950-262-262-687-262-950 0-262 262-262 688 0 950zM12017 6655c-262 263-687 263-949 0-263-262-263-687 0-949 262-263 687-263 949 0 263 262 263 687 0 949zM10230 4868c-262 262-688 262-950 0-262-263-262-688 0-950 263-262 688-262 950 0s262 687 0 950zM8443 3080c-263 263-688 263-950 0-262-262-262-687 0-949 262-263 687-263 950 0 262 261 262 687 0 949z"
          className="fill stroke1"
          style={{
            strokeWidth: 292.757,
          }}
        />
        <path
          d="M6655 1293c-262 262-687 262-950 0-262-263-262-688 0-950 263-262 688-262 950 0 263 262 263 688 0 950zM6180 12470c371 0 672-300 672-671 0-372-301-672-672-672s-671 301-671 672c0 370 300 671 671 671zM6180 9942c371 0 672-300 672-672 0-370-301-671-672-671s-671 301-671 671c0 372 300 672 671 672zM6180 7415c371 0 672-301 672-672s-301-672-672-672-671 301-671 672 300 672 671 672zM6180 4887c371 0 672-301 672-672s-301-672-672-672-671 301-671 672 300 672 671 672zM6180 20054c371 0 672-301 672-672 0-370-301-671-672-671s-671 301-671 671c0 371 300 672 671 672zM6180 17526c371 0 672-300 672-672 0-370-301-671-672-671s-671 301-671 671c0 372 300 672 671 672zM6180 14998c371 0 672-300 672-671s-301-672-672-672-671 301-671 672c0 370 300 671 671 671z"
          className="fill stroke1"
          style={{
            strokeWidth: 292.757,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
